export default function ServicesGrid() {
  const services = [
    {
      icon: 'ri-brush-line',
      title: 'Limpieza de Hollín',
      description: 'Eliminación profesional de hollín y residuos de humo con técnicas específicas según material.',
      link: '/servicios#hollin'
    },
    {
      icon: 'ri-mist-line',
      title: 'Neutralización de Olores',
      description: 'Tratamientos profesionales para eliminar olores persistentes, no solo enmascararlos.',
      link: '/servicios#olores'
    },
    {
      icon: 'ri-delete-bin-line',
      title: 'Retirada de Enseres',
      description: 'Gestión segura de cenizas, escombros y enseres dañados con coordinación de perito.',
      link: '/servicios#cenizas'
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Cocinas Quemadas',
      description: 'Limpieza profunda especializada en cocinas con desengrase y tratamiento específico.',
      link: '/servicios#cocinas'
    },
    {
      icon: 'ri-shield-cross-line',
      title: 'Desinfección',
      description: 'Saneamiento completo y control de humedad para garantizar un ambiente seguro.',
      link: '/servicios#desinfeccion'
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Preparación para Reformas',
      description: 'Dejamos el espacio limpio y preparado para pintores y reformistas.',
      link: '/servicios#preparacion'
    }
  ];

  return (
    <section className="py-20 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-serif font-bold text-4xl md:text-5xl text-primary mb-6">
            Servicios especializados de limpieza post incendio
          </h2>
          <p className="text-textLight text-lg max-w-2xl mx-auto">
            Desde la primera inspección hasta la entrega final. Cada intervención adaptada a tus necesidades.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <a
              key={index}
              href={service.link}
              className="bg-bg rounded-lg p-8 hover:shadow-lg transition-all group cursor-pointer"
            >
              <div className="w-16 h-16 bg-secondary/10 rounded-lg flex items-center justify-center mb-6 group-hover:bg-secondary/20 transition-colors">
                <i className={`${service.icon} text-3xl text-secondary`}></i>
              </div>
              <h3 className="font-sans font-bold text-xl text-primary mb-4 group-hover:text-secondary transition-colors">
                {service.title}
              </h3>
              <p className="text-textLight leading-relaxed mb-4">
                {service.description}
              </p>
              <span className="text-secondary font-sans font-semibold text-sm group-hover:text-primary transition-colors">
                Ver detalles →
              </span>
            </a>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="/servicios"
            className="inline-block bg-primary text-white px-8 py-4 rounded-full font-sans font-semibold hover:bg-opacity-90 transition-all whitespace-nowrap cursor-pointer"
          >
            Ver todos los servicios
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}